import { render, staticRenderFns } from "./ChannelTypeTable.vue?vue&type=template&id=2e46029c&"
import script from "./ChannelTypeTable.vue?vue&type=script&lang=js&"
export * from "./ChannelTypeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports